__turbopack_context__.v({
  "author": "CompanyProfileTeaser-module-scss-module__GBkOsq__author",
  "card": "CompanyProfileTeaser-module-scss-module__GBkOsq__card",
  "container": "CompanyProfileTeaser-module-scss-module__GBkOsq__container",
  "content": "CompanyProfileTeaser-module-scss-module__GBkOsq__content",
  "cover": "CompanyProfileTeaser-module-scss-module__GBkOsq__cover",
  "header": "CompanyProfileTeaser-module-scss-module__GBkOsq__header",
  "inner": "CompanyProfileTeaser-module-scss-module__GBkOsq__inner",
  "logoWrapper": "CompanyProfileTeaser-module-scss-module__GBkOsq__logoWrapper",
  "main": "CompanyProfileTeaser-module-scss-module__GBkOsq__main",
  "secondary": "CompanyProfileTeaser-module-scss-module__GBkOsq__secondary",
  "spoiler": "CompanyProfileTeaser-module-scss-module__GBkOsq__spoiler",
  "title": "CompanyProfileTeaser-module-scss-module__GBkOsq__title",
});
